"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobile = exports.isTouch = void 0;
exports.isTouch = typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;
let isMobile = exports.isTouch;
exports.isMobile = isMobile;
if (typeof navigator !== 'undefined' && typeof navigator.userAgentData !== 'undefined')
    exports.isMobile = isMobile = navigator.userAgentData.mobile;
else if (!isMobile && typeof navigator !== 'undefined')
    exports.isMobile = isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
